var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 128,
    viewBox: "0 0 112 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.284447C37.473 0.284447 22.4 15.3574 22.4 33.8844C22.4 52.4115 37.473 67.4845 56 67.4845C74.527 67.4845 89.6 52.4115 89.6 33.8844C89.6 15.3574 74.527 0.284447 56 0.284447ZM97.8049 89.4352C88.6059 80.0949 76.4111 74.9511 63.4667 74.9511H48.5333C35.5891 74.9511 23.3941 80.0949 14.1951 89.4352C5.04124 98.7297 0 110.998 0 123.982C0 126.044 1.67154 127.716 3.73333 127.716H108.267C110.328 127.716 112 126.044 112 123.982C112 110.998 106.959 98.7297 97.8049 89.4352Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic-profile.249b1969434e953a604c7ac2d165bfba.svg";
export { ForwardRef as ReactComponent };